import { showNotification } from "@mantine/notifications"
import { useMutation, useQuery } from "@tanstack/react-query"

import { Regions } from "@costory/types/prisma-client"

import { apiClient } from "@costory/front/lib/apiClient"
import { queryClient } from "@costory/front/lib/queryClient"

export const useCurrentRegionQuery = () => {
  return useQuery({
    queryKey: ["currentRegion"],
    queryFn: async () => {
      const response = await apiClient.get<{ region: Regions }>("/region")
      return response.data.region
    },
  })
}

export const useUpdateRegionMutation = (onSuccess?: () => void) => {
  return useMutation({
    mutationFn: async (region: Regions) => {
      const response = await apiClient.put("/region/update", { region })
      return response.data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["currentRegion"] })
      showNotification({
        color: "green",
        title: "Success",
        message: "Region updated successfully!",
      })
      if (onSuccess) onSuccess()
    },
    onError: (error: { error: string }) => {
      showNotification({
        color: "red",
        title: "Error",
        message: error.error || "Failed to update region.",
      })
    },
  })
}
